module.exports = __webpack_public_path__ + "img/lang-31.d5ff6426.jpg";